import { type ServiceMethod } from '@/application/interfaces/service';

export type CategoriesMapItem = {
  name: string;
  url: string;
  children: CategoriesMapItem[];
};

export type Response = {
  data: CategoriesMapItem[];
};

const getCategoriesMap: ServiceMethod<Response> = (httpClient) => async () => {
  const { body: response } = await httpClient.get<Response>(
    '/api/v3/sitemap/category-tree'
  );

  return response;
};

export default getCategoriesMap;
